<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> ປ່ຽນລະຫັດຜ່ານ</span>
        </div>
          
      </div>

      
      <div class="columns" >
          <div class="column">
            

            <div class="columns" >
              <div class="column">
                <b-field label="ລະຫັດຜ່ານເກົ່າ">
                  <b-input
                    v-model.trim="selectedOldPassword"
                    type="password"
                  >  
                  </b-input>
                </b-field>
              </div>
            </div>

            
            <div class="columns" >
              <div class="column">
                <b-field label="ລະຫັດຜ່ານໃໝ່">
                  <b-input
                    v-model.trim="selectedNewPassword"
                    type="password"
                  >  
                  </b-input>
                </b-field>
              </div>
            </div>
            <div class="columns" >
              <div class="column">
                <b-field label="">
                  <b-field label="ລະຫັດຜ່ານໃໝ່ ອີກຄັ້ງ">
                  <b-input
                    v-model.trim="selectedNewPasswordAgain"   
                    type="password"
                  >  
                  </b-input>
                </b-field>
                </b-field>
              </div>
            </div>

            <div class="columns" >
              
              <div class="column">
                <b-field label="" style="margin-top: 30px;">
                  <b-button
                      class="btn-group-margin is-fullwidth"
                      type="is-success"  
                      @click="changePassword()"
                      >  <span > ປ່ຽນລະຫັດຜ່ານ</span>
                  </b-button>
                </b-field>
              </div>
            </div>
          
            
            
            
          </div>
            
          <div class="column">
            
          </div>
          <div class="column">
            
          </div>
          
            
        </div>
      </div>
   

    

    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  // components: { Multiselect },

  props: {
    eventid: {
      type: String,
      required: false, // Make it optional to support both routes
    },
  },
  data() {
    return {
      roleid: null,
      userName: null,

      selectedOldPassword: null,
      selectedNewPassword: null,
      selectedNewPasswordAgain : null,
    
      
    };
     
    
  },
  methods: {     

    changePassword(){
      if(  !this.selectedOldPassword || this.selectedOldPassword === null || 
            !this.selectedNewPassword || this.selectedNewPassword === null ||  
            !this.selectedNewPasswordAgain || this.selectedNewPasswordAgain === null)     {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
              return false;
      }
      

      
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params = {
            username: this.username,
            oldpassword: this.sha2(this.selectedOldPassword),
            newpassword: this.sha2(this.selectedNewPassword),
            newpasswordagain: this.sha2(this.selectedNewPasswordAgain),
          };
            
            
            RestAPI.changePassword(params) 
              .then((res) => {

                  if(res.data.responseData.data=== 'Old password is not correct'){
                    this.$swal("Old password is not correct", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data=== 'New password must be different from old password'){
                    this.$swal("New password must be different from old password", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data=== 'New passwords must be the same'){
                    this.$swal("New passwords must be the same", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data=== 'SUCCESS'){
                    this.$swal({
                      title: "ສຳເລັດ",
                      text: "ປ່ຽນລະຫັດຜ່ານ ສຳເລັດ!",
                      icon: "success",
                      timer: 2000,
                      showConfirmButton: false, 
                    });

                    this.selectedNewPassword = "";
                    this.selectedOldPassword = "";
                    this.selectedNewPasswordAgain = "";

                    this.$router.replace("/login");

                  }else{
                    this.$swal("ມີຂໍ້ຜິດພາດ: " , "-", "error");
                  }

                  

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });
      
    },

    

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    // this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    this.username = this.user.USERNAME;   

    this.currentDate = new Date();
    
    this.getSection();
    this.getGender();
    this.getEventInfo();
    this.getAgeRang();
    this.getInterested();

    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
